import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pricing-item"
export default class extends Controller {
  static values = {
    prices: Array,
    cycle: { type: String, default: "yearly" },
  };

  static targets = ["price", "cycle", "link"];

  connect() {
    this.change();
  }

  change(event = null) {
    if (event) {
      this.cycleValue = event.detail.cycle;
    }
    const price = this.pricesValue.find(
      (price) => price.billing_cycle === this.cycleValue,
    );

    this.priceTarget.textContent = Number(price.price).toFixed(2);
    this.cycleTarget.textContent =
      this.cycleValue === "yearly" ? "/ year" : "/ month";
    let url = new URL(this.linkTarget.href);
    url.searchParams.set("cycle", this.cycleValue);
    url.searchParams.set("price_id", price.price_id);
    this.linkTarget.href = url;
  }
}
